<div class="modal-header bg-dark">
  <h4 class="modal-title" translate>Dokumente</h4>
  <button
    type="button"
    class="btn-close btn-close-white"
    aria-label="Close"
    (click)="modal.dismiss()"></button>
</div>
<div class="modal-body">
  @if (showAlert) {
    <app-mkde-alert type="danger" (dismiss)="showAlert = false">{{ alertMessage }}</app-mkde-alert>
  }
  @if (!fileNames || fileNames.length === 0) {
    <span translate>Es sind keine Dokumente vorhanden</span>
  }
  @if (fileNames && fileNames.length > 0) {
    <table class="table table-striped table-hover bsg-table mt-3">
      <tbody>
        @for (fileName of fileNames; track fileName) {
          <tr class="pointer-cursor">
            <td class="col-10" class="pointer-cursor" (click)="openFile(fileName)">
              {{ fileName }}
            </td>
            <td class="td-button col-1">
              <button class="btn btn-primary me-3 mt-1 mb-1" (click)="openFile(fileName)" translate>
                Öffnen
              </button>
            </td>
            <td class="td-button col-1">
              <button class="btn btn-primary me-2" (click)="openDeleteConfirmation(fileName)">
                <span translate>Entfernen</span>
              </button>
            </td>
          </tr>
        }
      </tbody>
    </table>
  }
</div>
<div class="modal-footer">
  <div>
    <input
      type="file"
      id="selectFile"
      class="hidden"
      #fileInput
      (change)="onFilesSelected()"
      multiple />
    <button class="btn btn-primary" onclick="document.getElementById('selectFile').click()">
      @if (isSavingDocuments) {
        <span class="fas fa-circle-notch fa-spin fa-fw"></span>
      }
      @if (!isSavingDocuments) {
        <span class="fas fa-plus-circle"></span>
      }
      <span translate>Dokument hinzufügen</span>
    </button>
  </div>
  <div>
    <button
      type="button"
      class="btn btn-outline-primary"
      (click)="modal.dismiss()"
      appAutofocus
      translate>
      Schliessen
    </button>
  </div>
</div>
